import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'timeAgo',
  standalone: true
})
export class TimeAgoPipe implements PipeTransform {
  transform(value: string | Date): string {
    if (!value) return '';

    const date = new Date(value);
    const now = new Date();
    const seconds = Math.floor((now.getTime() - date.getTime()) / 1000);

    if (seconds < 29) return 'agora';

    const intervals: { [key: string]: number } = {
      ano: 31536000,
      mês: 2592000,
      semana: 604800,
      dia: 86400,
      hora: 3600,
      minuto: 60,
      segundo: 1
    };

    let counter;
    for (const i in intervals) {
      counter = Math.floor(seconds / intervals[i]);
      if (counter > 0) {
        if (counter === 1) {
          return `há ${counter} ${i}`;
        } else {
          // Plural basic handling for pt-BR
          let unit = i;
          if (i === 'mês') unit = 'meses';
          else unit = i + 's';
          return `há ${counter} ${unit}`;
        }
      }
    }

    return 'agora';
  }
}
